import React, { useCallback } from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { ListView } from '@one-thd/sui-icons';
import _isEmpty from 'lodash/isEmpty';
import {
  usePromoStore, useDigitalDataStore, useDimensionsStore, useProductInfoStore
} from '../../../store';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import {
  ANALYTICS_EVENTS, NEW_RELIC_EVENTS, STACK_BUILDER
} from '../../../constants';

const StackSummary = () => {
  const openDrawer = usePromoStore((state) => state.openDrawer);
  const productInfo = useProductInfoStore((state) => state.productInfo);
  const trackModalLinkClickEvent = useDigitalDataStore((state) => state.trackModalLinkClickEvent);
  const stackDimensions = useDimensionsStore((state) => state.stackDimensions);
  const fulfillmentProducts = usePromoStore((state) => state.fulfillmentProducts);
  const handleOpenDrawer = useCallback(() => {
    openDrawer();
    trackModalLinkClickEvent(
      ANALYTICS_EVENTS.STACK_SUMMARY,
      stackDimensions,
      `${productInfo?.brand} ${STACK_BUILDER.TYPE}`
    );
    logNewRelicCustom(NEW_RELIC_EVENTS.LOAD_STACK_SUMMARY, fulfillmentProducts);
    logNewRelicCustom(NEW_RELIC_EVENTS.LOAD_STACK_DIMENSIONS, stackDimensions);
  }, [stackDimensions, fulfillmentProducts]);

  if (_isEmpty(fulfillmentProducts)) {
    return null;
  }
  return (
    <div
      role="button"
      tabIndex={0}
      type="button"
      onClick={handleOpenDrawer}
      className="sui-flex sui-flex-row sui-items-start sui-pt-4 sui-pl-4"
      style={{ minWidth: 170 }}
    >
      <span className="sui-pr-1">
        <ListView color="brand" />
      </span>
      <Typography color="primary" variant="body-xs" weight="bold">
        Stack Summary
      </Typography>
    </div>
  );
};

export default StackSummary;
